// extracted by mini-css-extract-plugin
module.exports = {"kitProductH5":"Product_kitProductH5__vlRvL"};